import ChannelDomain from "entities/domain/contacts/contact-domain";
import MerchantUserGuidesDomain from "entities/domain/admin/merchants/merchant-user-guides";
import TagsDomain from "../../tags/tags-domain";
import BankAccountDomain from "./bank-account-domain";
import ExternalMetadataDomain from "./external-metadata-domain";
import MerchantDomainBase, { TierType } from "./merchant-domain";
import MerchantTierLimitsDomain from "./merchant-tier-limits-domain";

class AdminMerchantDomain extends MerchantDomainBase {
  bankAccount?: BankAccountDomain;

  constructor(
    id: number,
    public_id: string,
    name: string,
    registeredCompanyId: string,
    subaccountSid: string,
    externalMetadata: ExternalMetadataDomain,
    channels: ChannelDomain[],
    hasStripeAccount: boolean,
    hasInvoiceAccount: boolean,
    hasOpenBanking: boolean,
    hasReviewsEnabled: boolean,
    tags: TagsDomain[],
    country: string,
    userGuides: MerchantUserGuidesDomain,
    businessDescription: string | null,
    tier: TierType | null,
    limits: MerchantTierLimitsDomain | null,
    bankAccount?: BankAccountDomain
  ) {
    super(
      id,
      public_id,
      name,
      registeredCompanyId,
      subaccountSid,
      externalMetadata,
      channels,
      hasStripeAccount,
      hasInvoiceAccount,
      hasOpenBanking,
      hasReviewsEnabled,
      [],
      "",
      tags,
      country,
      userGuides,
      businessDescription,
      tier,
      limits
    );

    this.id = id;
    this.public_id = public_id;
    this.name = name;
    this.registeredCompanyId = registeredCompanyId;
    this.subaccountSid = subaccountSid;
    this.externalMetadata = externalMetadata;
    this.channels = channels;
    this.hasStripeAccount = hasStripeAccount;
    this.hasInvoiceAccount = hasInvoiceAccount;
    this.bankAccount = bankAccount;
    this.hasOpenBanking = hasOpenBanking;
    this.hasReviewsEnabled = hasReviewsEnabled;
    this.tags = tags;
    this.userGuides = userGuides;
  }
}

export default AdminMerchantDomain;
